// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_GetBulkProgressResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for get_bulk_progress() /mensagens_programadas/get_bulk_progress
 * Returns progress statistics for a bulk operation from scheduler-service.
 * Mirrors the shape of ProgressApiResponse consumed by MensagensProgramadasLoteProgress.vue.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadas_GetBulkProgressResponseDados {
total?: number
completed?: number
sent?: number
failed?: number
pending?: number
processing?: number
}

export type MensagensProgramadas_GetBulkProgressResponse = ApiResponse<MensagensProgramadas_GetBulkProgressResponseDados>;

registerResponseContract('MensagensProgramadas_GetBulkProgressResponse', {
  total:      { type: 'number',  required: false },
  completed:  { type: 'number',  required: false },
  sent:       { type: 'number',  required: false },
  failed:     { type: 'number',  required: false },
  pending:    { type: 'number',  required: false },
  processing: { type: 'number',  required: false },
})
